import { Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { FeatureFlippingService, IFeaturesMap } from '@nimbus-global/features/feature-flipping/feature-flipping.service';
import { Feature } from '@nimbus-global/features/feature-flipping/feature.enum';
import { IMenuFilter } from '@nimbus-library/features/menu';

export class FeatureFlippingFilter implements IMenuFilter {
  public constructor(
    private readonly features$: Observable<IFeaturesMap>,
    private readonly feature: Feature,
  ) {}

  public validate$(): Observable<boolean> {
    return this.features$.pipe(map((features) => features[this.feature]));
  }
}

export class FeatureFlippingInFeatureManagementFilter implements IMenuFilter {
  public constructor(
    private readonly featureFlippingService: FeatureFlippingService,
    private readonly feature: Feature,
  ) {}

  public validate$(): Observable<boolean> {
    return this.featureFlippingService.isEnabledInFeatureManagement(this.feature);
  }
}

export class FeatureFlippingFilterFactory {
  private readonly features$: Observable<IFeaturesMap>;
  private trackedFeatures: Feature[];

  public constructor(private readonly featureFlippingService: FeatureFlippingService) {
    this.features$ = new Observable<IFeaturesMap>((observer) =>
      this.featureFlippingService.areEnabled$(this.trackedFeatures).subscribe({
        next: (features) => observer.next(features),
        error: (error) => observer.error(error),
        complete: () => observer.complete(),
      }),
    ).pipe(publishReplay(1), refCount());
    this.trackedFeatures = [];
  }

  public forFeature(feature: Feature): IMenuFilter {
    this.trackedFeatures.push(feature);
    return new FeatureFlippingFilter(this.features$, feature);
  }

  public forFeatureInFeatureManagement(feature: Feature): IMenuFilter {
    return new FeatureFlippingInFeatureManagementFilter(this.featureFlippingService, feature);
  }
}
